import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M10 7.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5m0 0V10m5 2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m0 0v-1.667c0-.5-.333-.833-.833-.833H5.833c-.5 0-.833.333-.833.833V12.5m0 0a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5"
    }, null, -1)
  ]))]))
}
export default { render: render }